import React, { FC, useState } from 'react'
import { isMobile } from 'react-device-detect'

import {
  WizzardPageBox,
  WizzardTrainingDaysRow,
} from '../style/UserWIzzardStyle'

import GenericInput from '../../../GenericComponents/GenericInput'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericCheckbox from '../../../GenericComponents/GenericCheckbox'

interface WizzardPage5Interface {
  handleChangeTrainingDay: Function
  chosenTrainingDays: any
  singleComponent: boolean
}

const WizzardPage5: FC<WizzardPage5Interface> = ({
  handleChangeTrainingDay,
  chosenTrainingDays,
  singleComponent,
}) => {
  const days = [
    { name: 'Poniedziałek', value: 1 },
    { name: 'Wtorek', value: 2 },
    { name: 'Środa', value: 3 },
    { name: 'Czwartek', value: 4 },
    { name: 'Piątek', value: 5 },
    { name: 'Sobota', value: 6 },
    { name: 'Niedziela', value: 7 },
  ]

  const checkboxContainerStyle = {
    display: 'flex',
    align: 'center',
    fDir: isMobile ? 'row' : 'column',
    justify: isMobile ? 'flex-start' : 'center',
    width: isMobile ? '30%' : 'unset',
    margin: isMobile ? '2% 0' : '0% 2%',
  }

  const checkboxStyle = {
    backgroundColor: '#342152',
    borderColor: '#342152',
    width: '20px',
    height: '20px',
  }

  return (
    <WizzardPageBox className="wizzard-training-info">
      <GenericTextSpan margin={'5% 0 3% 0'}>
        Zaznaczono
        <span className="accent-color">{chosenTrainingDays.length} z 5</span>
      </GenericTextSpan>
      <WizzardTrainingDaysRow>
        {days.map((day: any) => (
          <GenericCheckbox
            regulations={false}
            isCheckboxChecked={chosenTrainingDays.includes(day.value)}
            checkCheckbox={handleChangeTrainingDay}
            text={day.name}
            containerStyle={checkboxContainerStyle}
            checkboxStyle={checkboxStyle}
            name={day.value}
            defaultChecked={false}
            textMargin={isMobile ? '0 0 0 35%' : '10% 0 0 0'}
            textSize={'0.8rem'}
          />
        ))}
      </WizzardTrainingDaysRow>
    </WizzardPageBox>
  )
}

export default WizzardPage5
